<template>
  <div>

    <!-- bg_stars -->
    <div class="ui-bg-stars">
    </div>

    <!-- banner -->
    <div class="ui-uni-banner">
      <div class="container ref">
        <div class="title-box">
          <h1>
            {{lg('',{
              en: 'Battle',
              zh: '战斗',
            })}}
          </h1>
        </div>

        <img 
          class="banner-img" 
          src="/static/img/bg_uni_banner_03.png?v=2" 
          style="height: 200px; right:10px; bottom: -18px;"
        >
      </div>
    </div>
    
    <!-- comingsoon -->
    <div style="margin: 100px 0;">
      <div class="ui-uni-comingsoon bg-black">
        <h1>
          {{lg('',{
            en: 'Coming soon',
            zh: '敬请期待',
          })}}
        </h1>
      </div>
    </div>

    <div v-if="0" class="container my-5" style="max-width: 1300px;">
      <div class="ui-card px-4 py-3 mt-3">
        <span 
          @click="action_createRace()"
          class="btn btn-primary btn-sm mr-3"
          >
          Create Race
        </span>

        <button @click="btnTestApollo()">
          testApollo()
        </button>
      </div>

      <div class="mt-4">

        <div class="ui-tabset-style2 mb-4">
          <span @click="on_tab = 'start'" :class="['tab',{'on': on_tab === 'start'}]">
            {{lg('',{
              en: 'Events',
              zh: '',
            })}}
          </span>
          <span @click="on_tab = 'racing'" :class="['tab',{'on': on_tab === 'racing'}]">
            {{lg('',{
              en: 'Racing',
              zh: '',
            })}}
          </span>
          <span @click="on_tab = 'complete'" :class="['tab',{'on': on_tab === 'complete'}]">
            {{lg('',{
              en: 'Results',
              zh: '',
            })}}
          </span>
        </div>

        <div v-if="on_tab === 'start'" class="ui-tabset-style3 mb-4">
          <span class="op4 usn cd mr-4">
            RACES OPEN
          </span>

          <span @click="on_start_type = ''" :class="['tab',{'on': on_start_type === ''}]">
            {{lg('',{
              en: 'All',
              zh: '',
            })}}
          </span>

          <span 
            v-for="(item,index) of list_start_type"
            :key="index"
            @click="on_start_type = item" 
            :class="['tab',{'on': on_start_type === item}]"
            >
            {{item}}
          </span>
        </div>

        <!-- 表头 -->
        <div class="p-3 d-flex align-items-center justify-content-between text-small op4 border-top">
          <span style="width: 25%">EVENT</span>
          <span style="width: 15%">LOCATION</span>
          <span style="width: 15%">CLASS</span>
          <span style="width: 15%">DISTANCE</span>

          <!-- start -->
          <span v-if="on_tab == 'start'" style="width: 10%;">ENTRY FEE</span>
          <span v-if="on_tab == 'start'" style="width: 10%;">PRIZE POOL</span>
          <span v-if="on_tab == 'start'" style="width: 10%;" class="text-right">REGISTERED</span>

          <!-- racing -->
          <span v-if="on_tab == 'racing'" style="width: 15%;">PRIZE POOL</span>
          <span v-if="on_tab == 'racing'" style="width: 15%;" class="text-right">RUNS IN</span>

          <!-- complete -->
          <span v-if="on_tab == 'complete'" style="width: 15%;">DATE</span>
          <span v-if="on_tab == 'complete'" style="width: 15%;" class="text-right">PRIZE POOL</span>

          
        </div>

        <div v-if="on_tab === 'start'">
          
          <div 
            v-for="item of list_start"
            :key="item.id"
            >
            <raceItem
              :key="item.raceID"
              :data="item"
              :cfg_list_type="on_tab"

            />
          </div>
        </div>
        <div v-if="on_tab === 'racing'">
          <div 
            v-for="item of list_racing"
            :key="item.id"
            >
            <raceItem
              :key="item.raceID"
              :data="item"
              :cfg_list_type="on_tab"

              :cfg_no_gate_row="true"
              :cfg_show_gene_row="true"
            />
          </div>
        </div>
        <div v-if="on_tab === 'complete'">
          <div 
            v-for="item of list_complete"
            :key="item.id"
            >
            <raceItem
              :key="item.raceID"
              :data="item"
              :cfg_list_type="on_tab"

              :cfg_no_gate_row="true"
              :cfg_no_joined_row="true"
              :cfg_show_result_row="true"
            />
          </div>
        </div>
      </div>

      <popupSelectToRace/>
    </div>
    

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import raceItem from '@/views/_cp_busi/race_item.vue'
import popupSelectToRace from '@/views/_cp_busi/popup_select_to_race.vue'

export default {
  name: 'raceList',
  components: {
    raceItem,
    popupSelectToRace,
  },
  props: [],
  data() {
    return {

      // start racing complete
      on_tab:  'start',

      on_start_type: '',
      list_start_type: [
        'Griffin',
        'Class V',
        'Class IV',
        'Class III',
        'Class II',
        'Class I',
      ],
      
      list_start: [],
      list_racing: [],
      list_complete: [],
    }
  },
  computed: {},
  watch: {
    'on_tab'(){
      this.on_start_type = ''
      this.listRace()
    },
  },
  methods: {
    ...mapActions([
      'getAllRace',
      'createRace',
      'testApollo',
      'getRaceByStatus',
    ]),

    btnTestApollo(){
      let v = this
      v.testApollo(
        {
          address_my: v.$store.state.web3.account
        }
      )
    },

    action_createRace(){
      let v = this

      v.createRace({})
    },

    async listRace(){
      let v = this

      let map = {
        'start': 0,
        'racing': 1,
        'complete': 2,
      }
      let res = await v.getRaceByStatus( map[v.on_tab] )
      
      console.log('========Race ' + map[v.on_tab] )
      console.log(res)
      res = res.map(i => {
        let temp = Object.assign({},i)
        temp.mark_live = false
        return temp
      })

      if(v.on_tab === 'start'){
        v.list_start = res
      }
      else if (v.on_tab === 'racing'){
        v.list_racing = res
      }
      else if (v.on_tab === 'complete'){
        v.list_complete = res
      }
    },
    run(){
      // this.listRace()
    },
  },
  created() {
    this.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>